import React from 'react'
import './footer.css'
import {FaFacebookF} from 'react-icons/fa'
import {FaInstagram} from 'react-icons/fa'
import {FaLinkedin} from 'react-icons/fa'

const Footer = () => {
  return (
    <footer>
      <a href="#" className="footer__logo">Hamza</a>

      <ul className='permalinks'>
        <li><a href="#header">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Experience</a></li>
        <li><a href="#services">Services</a></li>
        <li><a href="#portfolio">Portfolio</a></li>
        <li><a href="#testimonials">Testimonials</a></li>
        <li><a href="#">Contact</a></li>
      </ul>

      <div className="footer__socials">
        <a href="https://www.facebook.com/ch.hamza.921230/"><FaFacebookF/></a>
        <a href="https://www.instagram.com/logodesignermaker/"><FaInstagram/></a>
        <a href="https://www.linkedin.com/in/hamza-ilyas-483506244/"><FaLinkedin/></a>
      </div>

      <div className="footer__copyright">
        <small>&copy;Hamza Ilyas All rights are reserved.</small>
      </div>
    </footer>
  )
}

export default Footer